import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { BreakdownLineItem } from '@jobos/shared';

interface UpsertResponse {
  item: BreakdownLineItem;
  created: boolean;
}

export function useEnsureEquipmentLineItem() {
  return useMutation({
    mutationFn: async (jobId: string) => {
      return apiClient.post<UpsertResponse>(`/jobs/${jobId}/equipment-line-item`, {});
    },
  });
}
